import { render, staticRenderFns } from "./IconInformationPresent.vue?vue&type=template&id=a8606a90"
import script from "./IconInformationPresent.vue?vue&type=script&lang=ts"
export * from "./IconInformationPresent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports